/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffRequestRecipient } from './StaffRequestRecipient';
import {
    StaffRequestRecipientFromJSON,
    StaffRequestRecipientFromJSONTyped,
    StaffRequestRecipientToJSON,
    StaffRequestRecipientToJSONTyped,
} from './StaffRequestRecipient';

/**
 * 
 * @export
 * @interface StaffRequestRecipientResponse
 */
export interface StaffRequestRecipientResponse {
    /**
     * 
     */
    data: StaffRequestRecipient;
}

/**
 * Check if a given object implements the StaffRequestRecipientResponse interface.
 */
export function instanceOfStaffRequestRecipientResponse(value: object): value is StaffRequestRecipientResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function StaffRequestRecipientResponseFromJSON(json: any): StaffRequestRecipientResponse {
    return StaffRequestRecipientResponseFromJSONTyped(json, false);
}

export function StaffRequestRecipientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffRequestRecipientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': StaffRequestRecipientFromJSON(json['data']),
    };
}

export function StaffRequestRecipientResponseToJSON(json: any): StaffRequestRecipientResponse {
    return StaffRequestRecipientResponseToJSONTyped(json, false);
}

export function StaffRequestRecipientResponseToJSONTyped(value?: StaffRequestRecipientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StaffRequestRecipientToJSON(value['data']),
    };
}

